import './purchase-prompt-telemetry.js';
import './navbar.js';
import './login.js';
import './subscription.js';
import './premium-reading-gate.js';
import './birthchart-pdf-offer.js';
import './birthchart-reading-path.js';
import './birthchart-reading-time.js';
import './birthchart-ai-analysis.js';

// Polyfill for String.padStart (ES2017)
// Required for old browsers: Chrome <57, Samsung Internet <7.0, IE, Safari <10
if (!String.prototype.padStart) {
    String.prototype.padStart = function padStart(targetLength, padString) {
        targetLength = targetLength >> 0;
        padString = String(typeof padString !== 'undefined' ? padString : ' ');
        var str = String(this);
        if (str.length >= targetLength) {
            return str;
        }
        var pad = '';
        var len = targetLength - str.length;
        while (pad.length < len) {
            pad += padString;
        }
        return pad.slice(0, len) + str;
    };
}

// Import analytics if available
try {
    require('./analytics.js');
} catch (e) {
    // Analytics not available in this context, continue without it
}

// Signup form tracking
document.addEventListener('DOMContentLoaded', function () {
    const signupForm = document.querySelector('[data-am-signup-form]');

    if (signupForm) {
        const nameField = document.getElementById('name');
        const emailField = document.getElementById('email');
        let signupStartTracked = false;

        // Track signup start when user interacts with any form field
        const trackSignupStart = () => {
            if (!signupStartTracked && window.astrolooAnalytics) {
                // Determine source - check if user came from AI interaction
                const referrer = document.referrer;
                const urlParams = new URLSearchParams(window.location.search);
                const source = urlParams.get('source') ||
                             (referrer.includes('/mapa/') ? 'birthchart_ai' :
                              referrer.includes('/horoscopo') ? 'horoscope_ai' : 'direct');

                window.astrolooAnalytics.trackSignupStart(source);
                signupStartTracked = true;
            }
        };

        // Track on first field focus
        if (nameField) {
            nameField.addEventListener('focus', trackSignupStart, { once: true });
        }
        if (emailField) {
            emailField.addEventListener('focus', trackSignupStart, { once: true });
        }

        // Track form submission
        signupForm.addEventListener('submit', () => {
            if (window.astrolooAnalytics) {
                const referrer = document.referrer;
                const urlParams = new URLSearchParams(window.location.search);
                const source = urlParams.get('source') ||
                             (referrer.includes('/mapa/') ? 'birthchart_ai' :
                              referrer.includes('/horoscopo') ? 'horoscope_ai' : 'direct');

                window.astrolooAnalytics.trackConversion('signup_attempt', source);
            }
        });
    }

    // Check if we just completed signup (arrived at /mapas from signup)
    if (window.location.pathname === '/mapas' && document.referrer.includes('/cadastrar')) {
        if (window.astrolooAnalytics) {
            const source = new URLSearchParams(document.referrer.split('?')[1] || '').get('source') || 'direct';
            window.astrolooAnalytics.trackSignupComplete(source);
            window.astrolooAnalytics.trackConversion('signup_complete', source);
        }
    }
});
